import * as React from 'react';
import { FC, ReactElement } from 'react';

import { CTA, styled } from '@volkswagen-onehub/components-core';
import { css } from 'styled-components';

import translate from '../../utils/translate';

interface SphereControlButtonProps {
	onClick?: () => void;
	ariaLabel: string;
	icon: ReactElement;
	disabled?: boolean;
	testId: string;
	gridArea?: string;
}

const SphereButton: FC<SphereControlButtonProps> = ({ onClick, icon, ariaLabel, disabled, testId, gridArea }) => {
	return (
		<StyledCTA
			data-testid={testId}
			tag="button"
			type="button"
			aria-label={translate(`global.ariaLabel.${ariaLabel}`)}
			emphasis="tertiary"
			onClick={onClick}
			icon={icon}
			disabled={disabled}
			gridArea={gridArea}
		/>
	);
};

const StyledCTA = styled(CTA)<{ disabled?: boolean; gridArea?: string }>`
	${({ gridArea }) => gridArea && `grid-area: ${gridArea};`}
	${({ theme, disabled }) =>
		theme.variant === 'v26' &&
		css`
			&& {
				width: 24px;
				height: 24px;
				min-width: 24px;
				min-height: 24px;
				padding: 0;
				margin: 0;
				border: 0;
				border-radius: 0;
				background: transparent;
				color: ${disabled ? 'rgba(255, 255, 255, 0.35)' : '#ffffff'};
			}

			&&:hover,
			&&:active,
			&&:focus:not(:focus-visible) {
				background: transparent;
				color: ${disabled ? 'rgba(255, 255, 255, 0.35)' : '#ffffff'};
			}

			&& svg {
				width: 24px;
				height: 24px;
			}

			&& svg [stroke] {
				stroke: currentColor;
			}

			&& svg path[fill]:not([fill='none']) {
				fill: currentColor;
			}
		`}
`;
export default SphereButton;
